import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getDashboardDataProduct = async (
  classificacao: Classification | undefined,
  tipo: DataType,
  dataInicio: string,
  dataFim: string,
  page: number
): Promise<TableDashboard | { message: string }> => {
  try {
    const result = await apiService.get(`app/dashboard/${tipo}`, {
      params: {
        classificacao,
        dataFim,
        dataInicio,
        page: page - 1,
        size: 7,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getDashboardDataClient = async (
  classificacao: Classification | undefined,
  tipo: DataType,
  dataInicio: string,
  dataFim: string,
  page: number
): Promise<TableDashboard | { message: string }> => {
  try {
    const result = await apiService.get(`app/dashboard/${tipo}`, {
      params: {
        classificacao,
        dataFim,
        dataInicio,
        page: page - 1,
        size: 7,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getDashboardResume = async (
  dataFim: string,
  dataInicio: string
): Promise<GetDashboardResumeType | { message: string }> => {
  try {
    const result = await apiService.get(`app/dashboard/resumo`, {
      params: {
        dataFim,
        dataInicio,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'error',
  }
}
